import { render, staticRenderFns } from "./ShopGridSelector.vue?vue&type=template&id=463140e6&scoped=true"
import script from "./ShopGridSelector.vue?vue&type=script&lang=js"
export * from "./ShopGridSelector.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "463140e6",
  null
  
)

export default component.exports